export default "__VITE_ASSET__a2f00869__"